<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        
        <input :id="id" ref="input" v-bind="$attrs" class="form-input" :class="{ error: error }" type="checkbox" :value="value" @input="$emit('input', $event.target.value)" />

    <!-- <input :id="id" :value="value"    class="mr-1"  type="checkbox"  ref="input" v-bind="$attrs"  :class="{ error: error }"   /> -->
    <div v-if="error" class="form-error">{{ error }}</div>
    {{ value }}
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    value: String,
    label: String,
    error: String,
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
